import { useClass } from '@/hooks/useClass'

import { IconWrapper } from '../Icon'

export type GradationButtonProps = React.ComponentProps<'button'> & {
  leftIcon?: React.ReactNode
  rightIcon?: React.ReactNode
  variantType?: 'primary' | 'secondary'
  size: 'xs' | 'sm' | 'md' | 'lg'
}

const buttonSizeClassList = {
  xs: 'inline-flex px-16 py-8',
  sm: 'inline-flex h-[48px] px-48',
  md: 'flex w-1/2 h-[48px]',
  lg: 'flex w-full h-[48px]',
}

const messageSizeClassList = {
  xs: 'text-2xs',
  sm: 'text-sm',
  md: 'text-sm',
  lg: 'text-sm',
}

const variantTypeClassList = {
  primary: {
    _: 'bg-primary-gradient text-primary bump-shadow-primary',
    disabled: 'bg-disabled text-primary-light bump-shadow-disabled',
  },
  secondary: {
    _: 'bg-black text-primary-gradient bump-shadow-primary',
    disabled: 'bg-disabled text-primary-gradient',
  },
}

/**
 * secondaryの場合、以下のようにdivなどでwrapし、背景色を指定する
 * <div className="bg-black rounded-full">
 *  <GradationButton variantType="secondary" />
 * </div>
 */
export const GradationButton = ({
  disabled,
  children,
  leftIcon,
  rightIcon,
  variantType = 'primary',
  size,
  onClick,
  type,
  className,
}: GradationButtonProps) => {
  const buttonClass = useClass(
    'items-center justify-center rounded-[35px] font-bold',
    buttonSizeClassList[size],
    messageSizeClassList[size],
    variantTypeClassList[variantType][disabled ? 'disabled' : '_'],
    className
  )

  return (
    <button
      type={type ?? 'button'}
      className={buttonClass}
      onClick={onClick}
      disabled={disabled}
    >
      {leftIcon && (
        <IconWrapper className="mr-4 text-2xl fill-primary">
          {leftIcon}
        </IconWrapper>
      )}
      {children}
      {rightIcon && (
        <IconWrapper className="ml-4 text-md fill-primary">
          {rightIcon}
        </IconWrapper>
      )}
    </button>
  )
}
